import React from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query';
import { useApiQuery } from '../../../../../../api/hooks';
import { Endpoints, QueryKey } from '../../../../../../views/democracy/constants';
import { normalizeSanctionTypes } from './sanctionsModel';
import SanctionSection from './SanctionSection';
import './sanctions.css';

// Под-таб «Санкции»: карточки санкций, сгруппированные по типам.
export default function SanctionsPanel({ democracy }) {
    const queryClient = useQueryClient();
    const democracyId = democracy.id;

    const { data: typesRaw } = useApiQuery(QueryKey.sanctionTypes, Endpoints.sanctions.types, { refetchOnMount: 'always' });
    const { data: rawList, isLoading } = useApiQuery(
        QueryKey.sanctions(democracyId),
        Endpoints.sanctions.listForDemocracy(democracyId),
        { refetchOnMount: 'always', enabled: !!democracyId }
    );

    if (isLoading) return <div className="vp-empty">Загрузка…</div>;
    if (!rawList) return null;

    const sanctions = (rawList || []).filter(s => s && s.id != null);
    const types = normalizeSanctionTypes(typesRaw).sort((a, b) => (a.orderId || 0) - (b.orderId || 0));
    const invalidate = () => queryClient.invalidateQueries({ queryKey: QueryKey.sanctions(democracyId) });

    return (
        <>
            {types.map(type => (
                <SanctionSection
                    key={type.name}
                    sanctionType={type}
                    sanctions={sanctions.filter(s => s.sanctionType === type.name)}
                    democracyId={democracyId}
                    onChanged={invalidate}
                />
            ))}
        </>
    );
}

SanctionsPanel.propTypes = {
    democracy: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired
};
